import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysNotice.list.update']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 600 }
      }, {
        type: _withCtx(({ scope }) => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getTypeArray(scope.record.type), (typeValue) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: typeValue,
                color: $setup.getTypeColor(typeValue),
                style: {"margin-right":"8px","margin-bottom":"4px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.getTypeLabel(typeValue)), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ])
        ]),
        control: _withCtx(({ scope }) => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.editClick(scope.record))
          }, {
            default: _withCtx(() => [
              _createTextVNode("编辑")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'sysNotice.list.update']
          ]),
          _createVNode(_component_a_popconfirm, {
            title: "确定要删除吗？",
            onConfirm: ($event: any) => ($setup.delClick(scope.record)),
            "ok-text": "确定",
            "cancel-text": "取消"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                danger: "",
                size: "small",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 1
              })), [
                [_directive_permission, 'sysNotice.list.del']
              ])
            ]),
            _: 2
          }, 1032, ["onConfirm"])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: $setup.isAdd ? '添加' : '编辑',
      visible: $setup.dislogVisible,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => {$setup.dislogVisible = false; $setup.addLoading = false;}),
      onIsDestroyOnClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.addLoading = false)),
      onConfirm: $setup.confirm,
      loading: $setup.addLoading,
      width: "560px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 5, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "邮箱",
              name: "email",
              rules: [
          { required: true, message: '请输入邮箱!' },
          { type: 'email', message: '请输入正确的邮箱格式!' },
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入邮箱",
                  value: $setup.formState.email,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.formState.email) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "通知类型",
              name: "typeArray"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox_group, {
                  value: $setup.formState.typeArray,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.formState.typeArray) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("支付管理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("工单管理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("名称待办")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode("账户申请")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode("资金清零")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onConfirm", "loading"])
  ], 64))
}